import { useRoutes } from 'react-router-dom';

import { IdleReset } from './components/IdleReset';
import { PrinterBanner } from './components/PrinterBanner';
import { useKioskHeartbeat } from './lib/useKioskHeartbeat';
import { routes } from './routes';

/**
 * KIOSK 應用殼層。
 *
 * - useKioskHeartbeat：背景每 30s 回報存活 → CMS 設備儀表板顯示在線（AC-H-3）。
 * - IdleReset：閒置 30 秒（付款進行中除外）清除購票草稿並回 Attract。
 * - PrinterBanner：印表機缺紙時頂部 HW-004 橫幅。
 * - useRoutes：購票主流程為線性 wizard，每畫面一條 route。
 */
export function App(): JSX.Element | null {
  useKioskHeartbeat();
  const element = useRoutes(routes);
  return (
    <>
      <IdleReset />
      <PrinterBanner />
      {element}
    </>
  );
}
